import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router';
import { SignUpForm, type SignUpFormData } from '@/components/auth/sign-up-form';
import { BrandLogo } from '@/components/common/brand-logo';
import useSignUp from '@/hooks/auth/use-sign-up';
import ROUTES from '@/routes';

export default function SignUpRoute() {
  const { t } = useTranslation();
  const { signUp, isPending } = useSignUp();
  const navigate = useNavigate();

  const handleSignUp = async (data: SignUpFormData) => {
    const response = await signUp({
      Phone: data.phoneNumber,
      TelCode: data.countryCode,
      Code: data.oneTimeCode,
    });

    if (response) {
      navigate(ROUTES.AUTH.SETUP.$path());
    }

    return response;
  };

  return (
    <div className='flex flex-1 flex-col'>
      <div className='flex-1 flex flex-col justify-center'>
        <BrandLogo
          fetchPriority='high'
          variant='simple'
          className='mx-auto brand-ryuryu:h-40 h-30'
        />
      </div>
      <div className='mx-12 mb-16 flex flex-1 h-full max-h-60vh 4xl:max-h-40vh flex-col items-stretch first:mt-safe-offset-16'>
        <h2 className='mb-8 text-center text-2xl font-bold text-primary-content'>{t('auth.sign-up')}</h2>

        <SignUpForm
          navigateBack
          isLoading={isPending}
          onSubmit={handleSignUp}
        />

        <p className='mt-4 space-x-2 text-center text-primary-content'>
          {t('auth.sign-up-agreements.hint')}

          <br />

          <Link
            to={ROUTES.AUTH.AGREEMENT.$path()}
            className='link link-neutral'>
            {t('auth.sign-up-agreements.user')}
          </Link>

          <Link
            to={ROUTES.AUTH.PRIVACY.$path()}
            className='link link-neutral'>
            {t('auth.sign-up-agreements.privacy')}
          </Link>
        </p>
      </div>
    </div>
  );
}
